import { useState } from 'react';
import { Calendar, Download, Filter, Users } from 'lucide-react';
import PerformanceScorecard from '../dashboard/PerformanceScorecard';
import AgentPerformanceRating from '../dashboard/AgentPerformanceRating';

export default function AgentPerformanceTab() {
  const [dateRange, setDateRange] = useState({
    startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0],
  });
  const [teamFilter, setTeamFilter] = useState<string>('ALL');
  const [shiftFilter, setShiftFilter] = useState<string>('ALL');

  const teams = ['ALL', 'Technical Support', 'Phone Support', 'Live Chat', 'Email Support'];
  const shifts = ['ALL', 'Morning (6AM-2PM)', 'Day (9AM-5PM)', 'Evening (2PM-10PM)', 'Night (10PM-6AM)'];

  const handleExport = (format: 'pdf' | 'csv' | 'excel') => {
    console.log('Exporting performance data as', format);
    alert(`Exporting Agent Performance Report as ${format.toUpperCase()}...\n\nDate Range: ${dateRange.startDate} to ${dateRange.endDate}`);
  };

  return (
    <div className="space-y-6">
      {/* Filters and Actions Bar */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {/* Date Range */}
          <div className="flex items-center space-x-2">
            <Calendar className="h-4 w-4 text-gray-500" />
            <input
              type="date"
              value={dateRange.startDate}
              onChange={(e) => setDateRange({ ...dateRange, startDate: e.target.value })}
              className="px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <span className="text-gray-500">to</span>
            <input
              type="date"
              value={dateRange.endDate}
              onChange={(e) => setDateRange({ ...dateRange, endDate: e.target.value })}
              className="px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>

          {/* Team Filter */}
          <div className="flex items-center space-x-2">
            <Filter className="h-4 w-4 text-gray-500" />
            <select
              value={teamFilter}
              onChange={(e) => setTeamFilter(e.target.value)}
              className="px-3 py-2 text-sm font-medium border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
              {teams.map((team) => (
                <option key={team} value={team}>
                  {team === 'ALL' ? 'All Teams' : team}
                </option>
              ))}
            </select>
          </div>

          {/* Shift Filter */}
          <div className="flex items-center space-x-2">
            <Users className="h-4 w-4 text-gray-500" />
            <select
              value={shiftFilter}
              onChange={(e) => setShiftFilter(e.target.value)}
              className="px-3 py-2 text-sm font-medium border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
              {shifts.map((shift) => (
                <option key={shift} value={shift}>
                  {shift === 'ALL' ? 'All Shifts' : shift}
                </option>
              ))}
            </select>
          </div>

          {/* Active filters badge */}
          {(teamFilter !== 'ALL' || shiftFilter !== 'ALL') && (
            <span className="text-xs px-2 py-1 bg-purple-100 text-purple-700 rounded-full">
              Filters active
            </span>
          )}
        </div>

        {/* Export Actions */}
        <div className="flex items-center space-x-2">
          <button
            onClick={() => handleExport('pdf')}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            <Download className="h-4 w-4 inline mr-2" />
            PDF
          </button>
          <button
            onClick={() => handleExport('csv')}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            <Download className="h-4 w-4 inline mr-2" />
            CSV
          </button>
          <button
            onClick={() => handleExport('excel')}
            className="px-4 py-2 text-sm font-medium text-white bg-purple-600 rounded-md hover:bg-purple-700"
          >
            <Download className="h-4 w-4 inline mr-2" />
            Excel
          </button>
        </div>
      </div>

      {/* Performance Scorecard */}
      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Team Performance Overview</h2>
        <PerformanceScorecard />
      </div>

      {/* Agent Performance Ratings */}
      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Individual Agent Rankings</h2>
        <AgentPerformanceRating />
      </div>
    </div>
  );
}
